/**
 * @file api/setup.js
 * @description API functions for the first-run setup wizard (/api/setup/*).
 * These calls don't require Entra ID auth except promote-admin, which apiClient
 * attaches automatically once the user has signed in.
 */

import apiClient from './client';

/** @returns {Promise<{dbReachable: boolean, schemaReady: boolean, adminExists: boolean, setupComplete: boolean}>} */
export const getSetupStatus = async () => {
  const res = await apiClient.get('/api/setup/status');
  return res.data;
};

/**
 * @param {string} setupToken
 * @param {{ db?: object, azure?: object }} payload
 */
export const saveSetupEnv = async (setupToken, payload) => {
  const res = await apiClient.post('/api/setup/env', payload, {
    headers: { 'X-Setup-Token': setupToken },
  });
  return res.data;
};

/** @param {string} setupToken */
export const initSetupDb = async (setupToken) => {
  const res = await apiClient.post('/api/setup/init-db', {}, {
    headers: { 'X-Setup-Token': setupToken },
  });
  return res.data;
};

/** @param {string} setupToken */
export const promoteSetupAdmin = async (setupToken) => {
  const res = await apiClient.post('/api/setup/promote-admin', {}, {
    headers: { 'X-Setup-Token': setupToken },
  });
  return res.data;
};
